import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };
    case actionTypes.GET_USERS_BY_USER_ID_SUCCESS:
      return { ...state, actionProcessing: false, users: action.payload };
    case actionTypes.SELECT_AGENT_ID:
      return { ...state, selectedAgentId: action.payload };
    case actionTypes.AGENT_CLICKED:
      return { ...state, agentClickedTrigger: {} };
    case actionTypes.SET_PARENT_TREE:
      return { ...state, parentTree: action.payload };
    case actionTypes.SET_SEARCH_TREE:
      return { ...state, searchTree: action.payload };
    default:
      return { ...state };
  }
};
